module.exports = __webpack_public_path__ + "img/new image - nvd53.c167172c.jpg";